export const useLocalStorage = (cocode) => {
    const getLocalStorage = () => {
        
        const local = sessionStorage.getItem("cocode")
        if (local != null) {
            return JSON.parse(local)
        }
        return null
    }
    const setLocalStorage = (item) => {

        sessionStorage.setItem("cocode", item)
    }
    const removeLocalStorage = () => {
        return sessionStorage.removeItem("cocode")
    }
    return [getLocalStorage, setLocalStorage, removeLocalStorage]
}